<template>
    <div class="businemain">
        <div class="left" :style="{'background-color':obj.color}"></div>
        <div class="right">
            <div class="title"><h3>{{obj.title}}</h3></div>
            <div class="maindesc">
                <!-- <div class="desctile"><h6>{{obj.title}}</h6></div> -->
                <div class="desc">{{obj.desc}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['obj']
}
</script>

<style lang="less">
    .businemain{
        display: flex;
        display: -webkit-flex;
        height: 200px;
        width: 100%;
        border-radius: 5px;
        box-shadow: 1px 1px 1px 1px #F1F1F1;
        margin-top: 50px;
        .left{
            height: 100%;
            width: 200px;
            border-top-left-radius: 5px;
            border-bottom-left-radius:5px;
        }
        .right{
            width: 100%;
            padding-left: 10px;
            .title{
                border-bottom: 1px solid #FBFBFB;
                font-size: 16px;
                margin-bottom: 30px;
            }
            .maindesc{
                .desctile{
                    color: red;
                    margin-bottom: 16px;
                }
                .desc{
                    color: #6f6f6f;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/busineSssector.vue